// extracted by mini-css-extract-plugin
export default {"invalid":"AccesoriosEdit_invalid__I1frw","spinnerContainer":"AccesoriosEdit_spinnerContainer__Esegj"};